<svg width="24" height="24" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g transform="matrix(1,0,0,1,4,4.0001)">
        <path d="M8,0C3.6,0 0,3.6 0,8C0,12.4 3.6,16 8,16C12.4,16 16,12.4 16,8C16,3.6 12.4,0 8,0ZM11.006,3.928L6.13,8.827L3.268,7.477L11.006,3.928ZM10.867,11.07L10.636,10.961L10.639,10.954L6.527,9.015L11.006,3.928L10.867,11.07Z"/>
    </g>
</svg>
